import { Box } from '@opendoor/bricks-next';
import type { BoxProps } from '@opendoor/bricks-next';

interface ContainerProps extends BoxProps {
  children: React.ReactNode;
  noSectionSpacing?: boolean;
}

const Container = ({
  children,
  backgroundColor,
  style,
  noSectionSpacing,
  ...props
}: ContainerProps) => {
  return (
    <Box display="block" className={noSectionSpacing ? undefined : 'lp-section'}>
      <Box backgroundColor={backgroundColor} style={style}>
        <Box
          display="block"
          maxWidth={1440}
          paddingHorizontal="$10x"
          $largerThanSM={{ paddingHorizontal: '$20x' }}
          $largerThanMD={{ paddingHorizontal: '$32x' }}
          width="100%"
          marginHorizontal="auto"
          {...props}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

const NetProceedsCalculatorContainer = ({ children, ...props }: ContainerProps) => {
  return (
    <Box
      display="block"
      maxWidth={1440}
      paddingHorizontal="$10x"
      $largerThanSM={{ paddingHorizontal: '$20x' }}
      $largerThanMD={{ paddingHorizontal: '$32x' }}
      width="100%"
      marginHorizontal="auto"
      {...props}
    >
      {children}
    </Box>
  );
};

const LandingPageSectionContainer = ({ children, ...boxProps }: ContainerProps) => {
  return (
    <Box display="block" className="lp-section">
      <Box
        marginTop="$16x"
        display="block"
        maxWidth={1440}
        paddingHorizontal="$10x"
        $largerThanSM={{ paddingHorizontal: '$20x' }}
        $largerThanMD={{ paddingHorizontal: '$32x' }}
        width="100%"
        marginHorizontal="auto"
        {...boxProps}
      >
        {children}
      </Box>
    </Box>
  );
};

export { LandingPageSectionContainer, NetProceedsCalculatorContainer };

export default Container;
